import * as Yup from "yup";

export const CreatePositionSchema = Yup.object().shape({
  position: Yup.string().required(""),
  skills: Yup
    .array()
    .of(
      Yup.string().required("").test('unique skill', 'Skill already existed', function(value) {
        const skills = this.parent;
        return skills.filter((item: string) => item?.toLowerCase() === value?.toLowerCase()).length < 2;
      }).matches(/^[^\s]+(\s+[^\s]+)*$/, " ")
    )
    .min(1, '')
    .required(""),
});
